import Column from '@app/components/layout/Column'
import { Event } from '@app/components/blocks/event/Event'
import { Title } from '@app/components/core/typography/Title'
import { useTranslations } from '@i18n/useLanguage'
import { ViewTopicCommunityModel } from 'functions/app/topic-community/view'
import { Text } from '@app/components/core/typography/Text'

export const TopicCommunityPageEvents = ({
  topicCommunity,
}: {
  topicCommunity: ViewTopicCommunityModel
}) => {
  const t = useTranslations().app
  const events = topicCommunity?.events ?? []

  if (events.length === 0) {
    return (
      <Column gap="1rem">
        <Title.H4>{t.topicCommunityPage.tabs.events}</Title.H4>
        <Text.Medium color="var(--shades-blue-600)">
          {t.topicCommunityPage.noEvents}
        </Text.Medium>
      </Column>
    )
  }

  return (
    <Column gap="1.5rem">
      <Title.H4>{t.topicCommunityPage.tabs.events}</Title.H4>
      {events.map((event) => {
        const startDate = new Date(event.start)
        const month = startDate.toLocaleDateString('en-US', { month: 'long' })
        const time = startDate.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
        })

        const isValidLink = event.link && /^https?:\/\//.test(event.link)

        return (
          <Event
            key={event.uuid}
            date={startDate.getDate()}
            month={month}
            category={event.category ?? ''}
            title={event.title}
            description={event.description}
            time={time}
            location={event.location?.address ?? t.common.notSpecified}
            onClick={
              isValidLink
                ? () => window.open(event.link, '_blank', 'noopener')
                : undefined
            }
          />
        )
      })}
    </Column>
  )
}
